// @flow
import React from 'react';
import './styles.css';
import type {OverviewItem} from '../../utils/types';

type Props = {
  items: Array<OverviewItem>
};

export default function Overview({ items = [] }: Props) {
  return (
    <ul className="Overview">
      {
        items.map((item: OverviewItem, index: number) => (
          <li className="Overview__item" key={index}>
            <span className="Overview__item__title">{item.title}</span> {item.value}
          </li>
        ))
      }
    </ul>
  );
}
